var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.List),function(item){return _c('CardReleaseList',{key:item.id,staticStyle:{"margin":"15px"},attrs:{"date":item.date}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }